import { render, staticRenderFns } from "./NeoparentLanguage.vue?vue&type=template&id=0265037a&scoped=true"
import script from "./NeoparentLanguage.vue?vue&type=script&lang=js"
export * from "./NeoparentLanguage.vue?vue&type=script&lang=js"
import style0 from "./NeoparentLanguage.vue?vue&type=style&index=0&id=0265037a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0265037a",
  null
  
)

export default component.exports